/**
 * Helpers for the experience gallery field.
 *
 * UAT-217: on the draft-edit path (`/experience/edit/:id`) EditExperiencePage maps every gallery
 * image to `{ id: img.id, image: img.image }`, so the `id` KEY always exists — even for a not-yet-
 * persisted image, where its VALUE is `undefined`. The old `'id' in img` presence check therefore
 * treated id-less images as server-persisted and called delete with `image_id: undefined` (→ HTTP
 * 400, error alert, image not removed).
 *
 * Fix: validate the actual id VALUE. `getPersistedImageId` returns the numeric id of a
 * server-persisted image, or `null` when the image only exists client-side (a File, a bare URL
 * string, or an object whose `id` is absent/undefined/non-numeric).
 */
export const getPersistedImageId = (img: unknown): number | null => {
  if (!img || typeof img !== 'object') return null // File, string URL, null, etc. → local-only
  const raw = (img as {id?: unknown}).id
  if (raw === undefined || raw === null || raw === '') return null
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
}
